import { ShieldCheck, ShieldOff, ShieldQuestion } from 'lucide-react-native';
import type { ReactNode } from 'react';
import { Badge } from '../../../components/primitives/Badge';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import type { ConsentTypeStatus } from '../../../types/consent';

interface ConsentBadgeProps {
  status: ConsentTypeStatus | null | undefined;
  size?: 'sm' | 'md';
}

export function ConsentBadge({ status, size = 'sm' }: Readonly<ConsentBadgeProps>) {
  const { t } = useTranslation();
  const iconSize = size === 'sm' ? 12 : 14;

  let color: 'green' | 'red' | 'amber';
  let label: string;
  let icon: ReactNode;

  if (!status) {
    color = 'amber';
    label = t('leads.detail.consent.unknown');
    icon = <ShieldQuestion size={iconSize} color={colors.status.warning.light} strokeWidth={1.8} />;
  } else if (status.granted) {
    color = 'green';
    label = t('leads.detail.consent.granted');
    icon = <ShieldCheck size={iconSize} color={colors.status.success.light} strokeWidth={1.8} />;
  } else {
    color = 'red';
    label = t('leads.detail.consent.notGranted');
    icon = <ShieldOff size={iconSize} color={colors.status.error.light} strokeWidth={1.8} />;
  }

  return (
    <Badge color={color} size={size} icon={icon} accessibilityLabel={label}>
      {label}
    </Badge>
  );
}
